import { formatUnitForecast, formatCurrency, formatCurrencyOrHide, formatCompactNumber } from '~/utils/unitFormatters';
const PLACEHOLDER_PROJECT_EXPRESSION_COUNT = '+3';
const PLACEHOLDER_EXPRESSION_PROJECT_COUNT = '+2';
export const cardConfigurations = {
    project: (data) => {
        const card = data;
        const seasonArray = 'season' in card && Array.isArray(card.season) ? card.season : null;
        const firstSeasonId = seasonArray &&
            seasonArray[0] &&
            typeof seasonArray[0] === 'object' &&
            'id' in seasonArray[0]
            ? String(seasonArray[0].id).toUpperCase()
            : null;
        const creationTrackLabel = 'creationTrack' in card &&
            typeof card.creationTrack === 'object' &&
            card.creationTrack !== null &&
            'label' in card.creationTrack
            ? String(card.creationTrack.label)
            : null;
        const imageOverlayLeftPills = firstSeasonId ? [firstSeasonId] : null;
        const imageOverlayRightPills = creationTrackLabel
            ? [creationTrackLabel]
            : null;
        const genderPills = 'genderVariations' in card && Array.isArray(card.genderVariations)
            ? card.genderVariations
                .filter((g) => typeof g === 'object' && g !== null && 'label' in g)
                .map((g) => String(g.label))
            : null;
        const projectedUnitLabel = 'projectedUnit' in card &&
            typeof card.projectedUnit === 'object' &&
            card.projectedUnit !== null &&
            'label' in card.projectedUnit
            ? String(card.projectedUnit.label)
            : null;
        const franchiseLabel = 'franchise' in card &&
            typeof card.franchise === 'object' &&
            card.franchise !== null &&
            'label' in card.franchise
            ? String(card.franchise.label)
            : null;
        const msrpValue = 'msrp' in card && typeof card.msrp === 'string'
            ? formatCurrency(card.msrp)
            : null;
        return {
            icon1: null,
            icon1Tooltip: null,
            icon2: null,
            icon2Tooltip: null,
            imageOverlayLeftPills,
            imageOverlayRightPills,
            imageOverlayBottomRight: PLACEHOLDER_PROJECT_EXPRESSION_COUNT,
            imageOverlayBottomRightTooltip: null,
            title: 'projectName' in card && typeof card.projectName === 'string'
                ? card.projectName
                : 'Project',
            labelForSubtitle: null,
            subtitle: franchiseLabel ? `${franchiseLabel} Franchise` : null,
            labelForElement1: null,
            element1: null,
            element1Tooltip: null,
            labelForElement2: '1st Season Unit Forecast',
            element2: formatUnitForecast(projectedUnitLabel),
            labelForPillRound: null,
            pillRound: genderPills && genderPills.length > 0 ? genderPills : null,
            labelForPillSquareLeft: null,
            pillSquareLeft: ['New Tool', 'New Upper'],
            pillSquareLeftTooltip: null,
            labelForPillSquareRight: null,
            pillSquareRight: null,
            labelForDetail: 'MSRP',
            detail: msrpValue
        };
    },
    model: (data) => {
        const model = data;
        return {
            title: model.modelName || 'Model',
            icon1Tooltip: null,
            icon2Tooltip: null,
            imageOverlayBottomRight: null,
            imageOverlayBottomRightTooltip: null,
            pillSquareLeft: null,
            pillSquareLeftTooltip: null,
            pillSquareRight: null,
            element1Tooltip: null
        };
    },
    style: (data) => {
        const style = data;
        return {
            title: style.styleNumber || 'Style',
            icon1Tooltip: null,
            icon2Tooltip: null,
            imageOverlayBottomRight: null,
            imageOverlayBottomRightTooltip: null,
            pillSquareLeft: null,
            pillSquareLeftTooltip: null,
            pillSquareRight: null,
            element1Tooltip: null
        };
    },
    expression: (data) => {
        const card = data;
        const pillSquareLeft = 'distributionIntent' in card &&
            typeof card.distributionIntent === 'object' &&
            card.distributionIntent !== null &&
            'id' in card.distributionIntent
            ? [String(card.distributionIntent.id)]
            : null;
        const upchargeValue = 'upcharge' in card && typeof card.upcharge === 'string'
            ? formatCurrencyOrHide(card.upcharge)
            : null;
        const lifecycleText = 'lifecycle' in card &&
            typeof card.lifecycle === 'object' &&
            card.lifecycle !== null &&
            'label' in card.lifecycle
            ? `Lifecycle: ${card.lifecycle.label}`
            : null;
        const apparelTooltip = 'hasApparelConnection' in card &&
            card.hasApparelConnection === true &&
            'keyApparelConnect' in card &&
            Array.isArray(card.keyApparelConnect) &&
            card.keyApparelConnect.length > 0
            ? card.keyApparelConnect.join(', ')
            : null;
        const distributionTooltip = 'distributionIntent' in card &&
            typeof card.distributionIntent === 'object' &&
            card.distributionIntent !== null &&
            'label' in card.distributionIntent
            ? String(card.distributionIntent.label)
            : null;
        const seasonArray = 'season' in card && Array.isArray(card.season) ? card.season : null;
        const firstSeasonId = seasonArray &&
            seasonArray[0] &&
            typeof seasonArray[0] === 'object' &&
            'id' in seasonArray[0]
            ? String(seasonArray[0].id).toUpperCase()
            : null;
        return {
            icon1: 'hasApparelConnection' in card && card.hasApparelConnection === true
                ? 'ProfileSwoosh'
                : null,
            icon1Tooltip: apparelTooltip,
            icon2: null,
            icon2Tooltip: null,
            imageOverlayLeftPills: firstSeasonId ? [firstSeasonId] : null,
            imageOverlayRightPills: null,
            imageOverlayBottomRight: PLACEHOLDER_EXPRESSION_PROJECT_COUNT,
            imageOverlayBottomRightTooltip: null,
            title: 'expressionName' in card && typeof card.expressionName === 'string'
                ? card.expressionName
                : 'Expression',
            labelForSubtitle: null,
            subtitle: 'museDoors' in card && typeof card.museDoors === 'string'
                ? card.museDoors
                : null,
            labelForElement1: null,
            element1: lifecycleText,
            element1Tooltip: null,
            labelForElement2: null,
            element2: 'forecast' in card && typeof card.forecast === 'string'
                ? formatCompactNumber(card.forecast)
                : null,
            labelForPillRound: null,
            pillRound: 'gender' in card &&
                typeof card.gender === 'object' &&
                card.gender !== null &&
                'label' in card.gender
                ? [String(card.gender.label)]
                : null,
            labelForPillSquareLeft: null,
            pillSquareLeft: pillSquareLeft,
            pillSquareLeftTooltip: distributionTooltip,
            labelForPillSquareRight: null,
            pillSquareRight: null,
            labelForDetail: 'Upcharge',
            detail: upchargeValue
        };
    },
    product: (data) => {
        const product = data;
        return {
            title: product.productName || 'Product',
            icon1Tooltip: null,
            icon2Tooltip: null,
            imageOverlayBottomRight: null,
            imageOverlayBottomRightTooltip: null,
            pillSquareLeft: null,
            pillSquareLeftTooltip: null,
            pillSquareRight: null,
            element1Tooltip: null
        };
    }
};
